import { dateToX, parseDate } from "@/lib/gantt-utils";

// Vertical overlay lines showing the project's start_date and go_live_date.
// Rendered inside the gantt grid, so z-index is kept low (2) to sit below rows.
export default function ProjectBand({ project, range, pxPerDay }) {
  if (!project.start_date && !project.go_live_date) return null;
  const s = project.start_date ? dateToX(parseDate(project.start_date), range.start, pxPerDay) : null;
  const e = project.go_live_date ? dateToX(parseDate(project.go_live_date), range.start, pxPerDay) : null;
  return (
    <>
      {s != null && (
        <div
          className="absolute top-0 bottom-0 border-l-2 border-dashed border-emerald-600/60 z-[2] pointer-events-none"
          style={{ left: s }}
        >
          <div className="absolute top-1 left-1 text-[9px] font-mono-ibm uppercase tracking-widest text-emerald-700 bg-white px-1 rounded-md border border-emerald-200">
            Project Start
          </div>
        </div>
      )}
      {e != null && (
        <div
          className="absolute top-0 bottom-0 border-l-2 border-dashed border-blue-600/60 z-[2] pointer-events-none"
          style={{ left: e }}
        >
          <div className="absolute top-1 left-1 text-[9px] font-mono-ibm uppercase tracking-widest text-blue-700 bg-white px-1 rounded-md border border-blue-200">
            Go-Live
          </div>
        </div>
      )}
    </>
  );
}
